export const VALUE_SHOULD_NOT_BE_UNDEFINED_ERROR =
  'Value should not be `undefined`.'

export const ORGANISATION_ID_UNDEFINED =
  'Organisation ID should not be undefined'

export enum SentryErrorType {
  GQL_ERROR = 'gqlError',
  API_ERROR = 'apiError',
  COMPONENT_CRASH = 'componentCrash',
  COMPOSE_PATH_ERROR = 'composePathError',
  TYPESENSE_ERROR = 'typesenseError',
}
